export function getColorName(color) {
  switch (color) {
    case "grey":
      return "Shut it down";
    case "blue":
      return "Walking recovery";
    case "green":
      return "Base";
    case "orange":
      return "Push";
    case "red":
      return "All out";
    default:
      return " ";
  }
}
